import Header from '../components/Header.tsx'
import Footer from '../components/Footer.tsx'
import { Link } from 'react-router-dom'

export default function TermsPage() {
  return (
    <>
      <Header />
      <main className="shell legal-page">
        <article className="prose">
          <h1>Terms of Service</h1>
          <p>Effective date: August 8, 2026</p>
          <p>
            These Terms of Service govern your use of heicto.me and its HEIC conversion
            tools.
          </p>

          <h2>Acceptable use</h2>
          <p>
            Use the converter only for files you have the right to process. Do not use it
            to infringe intellectual property or local laws.
          </p>

          <h2>No warranty</h2>
          <p>
            heicto.me is provided "as is" without warranties of any kind. Disclaimers are
            limited to the maximum extent permitted by applicable local law.
          </p>

          <h2>HEVC patent notice</h2>
          <p>
            Converting HEIC files may involve HEVC/H.265 technology. You are responsible
            for ensuring your use complies with applicable patent and licensing
            requirements in your jurisdiction.
          </p>

          <h2>Contact us</h2>
          <p>
            Questions about these terms may be sent to{" "}
            <a href="mailto:support@heicto.me">support@heicto.me</a>.
          </p>

          <h2>Governing law</h2>
          <p>
            These Terms are governed by the laws of the user local jurisdiction, without
            regard to conflict of laws principles.
          </p>

          <p>
            <Link to="/">← Back to converter</Link>
          </p>
        </article>
      </main>
      <Footer />
    </>
  )
}
